<template>
  <div class="form-search-container OPTION view--btn-icon">
    <!-- <label class="form-label">{{label}}</label> -->
    <div class="form-group">
      <input
        type="text"
        class="form-input"
        :value="localValue"
        @input="input($event.target.value)"
        @keyup.enter.prevent="search"
      >
      <form-button
        class="icon--btn"
        icon="search"
        @click="search"
      ></form-button>

    </div>
  </div>
</template>

<script>
import eventBus from '@/component/common/EventBus'

export default {
  name: 'search-text',
  data () {
    return {
      localValue: '',
      searchType: ''
    }
  },
  created () {
    eventBus.$on('search-type', this.onSearchType)

    const { query } = this.$router.currentRoute
    this.localValue = query.search || ''
    this.searchType = query.searchType || ''
  },
  methods: {
    input (value) {
      this.localValue = value
    },
    search () {
      let { name, query } = this.$router.currentRoute
      query = {
        ...query,
        page: 1,
        search: this.localValue,
        searchType: this.searchType
      }
      if (!this.localValue) {
        delete query.search
      }
      if (!this.searchType) {
        delete query.searchType
      }
      this.$router.push({ name, query })
    },
    onSearchType (value) {
      this.searchType = value.searchType
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton')
  }
}
</script>
